module.exports = __webpack_public_path__ + "images/liinilaevad/apple-icon-114x114.png";